import { Box } from '@alf/uikit';
import { usePSDescriptions } from '../../../hooks/usePSDescriptions';

export const WalletColumn = ({ serviceId }: { serviceId: string }) => {
  const paymentServicesDescription = usePSDescriptions();
  const { name: serviceName = '' } =
    paymentServicesDescription[serviceId] || {};

  return <Box>{serviceName}</Box>;
};
